<template>
  <a-spin v-if="!EnterpriseId" style="display:block;"/>
  <div v-else class="defaultIcon">
    <img v-if="iconUrl && !imgError" :class="size" :src="iconUrl" @error="loadDefault()"/>
    <img v-else class="img" src="@/assets/images/app_default_img.png"/>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      imgError: false,
    };
  },
  inject: ['toUri'],
  props: {
    // item.icon
    tag: {
      type: String,
      default: () => {
        return null
      }
    },
    // item.url 跳转链接
    nowUrI: {
      type: String,
      default: () => {
        return null
      }
    },
    size: {
      type: String,
      default: () => {
        return 's5'
      }
    }
  },
  methods: {
    // 加载出错显示默认图片
    loadDefault() {
      this.imgError = true;
    }
  },
  computed: {
    EnterpriseId() {
      if (this.$store.getters.getUserInfo && this.$store.getters.getUserInfo.enterprise) {
        return this.$store.getters.getUserInfo.enterprise.id;
      } else {
        return '';
      }
    },
    iconUrl() {
      return this.tag;
    }
  }
};
</script>
<style scoped>
.defaultIcon {
  display: block;
  overflow: hidden;
  width: 100%;
}

.defaultIcon.s3 {
  width: 35%;

}

.defaultIcon.s4 {
  width: 45%;
}

.defaultIcon.s5 {
  width: 55%;
}

.defaultIcon.s6 {
  width: 65%;
}

.defaultIcon.s7 {
  width: 75%;
}

.defaultIcon.s8 {
  width: 85%;
}

.defaultIcon.s9 {
  width: 95%;
}

.defaultIcon.s10 {
  width: 100%;
}

.defaultIcon img {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/todoCenter/defaultIcon.vue